import { createSlice } from "@reduxjs/toolkit";

//initial State
const initialState = {
  _id: "",
  userName: "",
  role: "",
  token: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    setUser: (state, action) => {
      state._id = action.payload._id;
      state.userName = action.payload.userName;
      state.role = action.payload.role;
    },

    logOut: (state) => {
      state._id = "";
      state.userName = "";
      state.role = "";
      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

export const { login, setUser, logOut } = authSlice.actions;
export default authSlice.reducer;
